import { useEffect } from 'react';
import { observer } from 'mobx-react';

import { Input } from '@gamesb42/ui-kit';
import { appInfoInst } from '.';

const Step5 = observer(() => {
  useEffect(() => {
    // Step5 всегда валиден (дополнительная информация необязательна)
    appInfoInst.isStepIsValid[5] = true;
  }, [appInfoInst.values.additionalInfo]);

  return (
    <>
      <h3 style={{ marginBottom: '20px' }}>
        <b>Additional info about the project</b>
      </h3>
      <Input.TextArea
        style={{ height: '140px' }}
        label="Comment"
        showCount
        maxLength={400}
        value={appInfoInst.values.additionalInfo}
        onChange={(e) => {
          appInfoInst.values.additionalInfo = e.target.value;
        }}
      />
    </>
  );
});

export default Step5;
